import {Tooltip} from "rsuite";
import React from "react";

const textStyle = {
  fontSize: 14,
  lineHeight: 1,
}

const p1Style = {
  marginBottom: 5,
  paddingBottom: 0,
  marginTop: 10
}
export const tooltip = (
  <Tooltip>
    <p style={{...textStyle, ...p1Style}}>
      Click here [anywhere on card] to view resident data.
    </p>
  </Tooltip>
);